"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class UploadTableColumnHeader extends _react.default.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      column
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: 'table-header align-top'
    }, column.displayName);
  }
}
var _default = exports.default = UploadTableColumnHeader;
module.exports = exports.default;